import { CalculatedConsumablesDemandThemeSizeConfig } from './types';

const small: CalculatedConsumablesDemandThemeSizeConfig = {
  calculatedConsumablesDemand: {},
};

export default small;
